import apiClient from './apiClient';

const locationService = {
  // Country Services
  getAllCountries: async () => {
    const response = await apiClient.post('/location/GetAllCountries');
    console.log('API Response:', response.data); // Debug için
    return response.data?.Data?.Items || [];
  },

  getCountryById: async (id) => {
    const response = await apiClient.post('/location/GetCountryById', null, { params: { id } });
    return response.data.Data;
  },

  addCountry: async (country) => {
    const response = await apiClient.post('/location/AddCountry', country);
    return response.data;
  },

  updateCountry: async (country) => {
    const response = await apiClient.post('/location/UpdateCountry', country);
    return response.data;
  },

  deleteCountry: async (id) => {
    const response = await apiClient.post('/location/DeleteCountry', null, { params: { id } });
    return response.data;
  },

  // City Services
  getAllCities: async () => {
    const response = await apiClient.post('/location/GetAllCities');
    return response.data.Data.Items || [];
  },

  getCityById: async (id) => {
    const response = await apiClient.post('/location/GetCityById', null, { params: { id } });
    return response.data.Data;
  },

  getCitiesByCountryId: async (countryId) => {
    const response = await apiClient.post('/location/GetCitiesByCountryId', null, { params: { id: countryId } });
    return response.data.Data.Items || [];
  },

  addCity: async (city) => {
    const response = await apiClient.post('/location/AddCity', city);
    return response.data;
  },

  updateCity: async (city) => {
    const response = await apiClient.post('/location/UpdateCity', city);
    return response.data;
  },

  deleteCity: async (id) => {
    const response = await apiClient.post('/location/DeleteCity', null, { params: { id } });
    return response.data;
  }
};

export default locationService;